import { render, staticRenderFns } from "./mini-task-notification.vue?vue&type=template&id=127bbff9&"
import script from "./mini-task-notification.ts?vue&type=script&lang=ts&"
export * from "./mini-task-notification.ts?vue&type=script&lang=ts&"
import style0 from "./mini-task-notification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.1_cache-loader@4.1.0_webpack@4.44.2__css-loader@3.5.2_webpack@4.44.2__lodash@_woylw74pnr2dauffvwh757gxea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports